import {
    Component,
    EventEmitter,
    Output,
    ViewChild,
    HostListener,
    ElementRef,
} from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GaService } from 'app/shared/services';

@Component({
    selector: 'clearcals-download-app-banner-mobile',
    templateUrl: './download-app-banner-mobile.component.html',
    styleUrls: ['./download-app-banner-mobile.component.scss'],
})
export default class DownloadAppBannerMobileComponent {
    @Output() sendEventToParent = new EventEmitter<boolean>();
    constructor(private gaService: GaService, private router: Router, private meta: Meta) {
        this.meta.addTag({
            rel: 'preload',
            href: './download-app-banner-mobile.component.scss',
            as: 'style',
        });
    }

    // GA click event
    clickDownloadAppBanner() {
        this.gaService.gaEventFun({
            action: 'download_app_banner_click',
            label: this.router.url,
        });
    }

    // GA view event
    @ViewChild('downloadAppBanner', { static: false })
    private downloadAppBanner: ElementRef<HTMLDivElement>;
    isDownloadAppBannerScrolledIntoView: boolean = false;

    @HostListener('window:scroll', ['$event'])
    isScrolledIntoView() {
        if (
            this.downloadAppBanner &&
            !this.isDownloadAppBannerScrolledIntoView
        ) {
            const rect =
                this.downloadAppBanner.nativeElement.getBoundingClientRect();
            const topShown = rect.top >= 0;
            const bottomShown = rect.bottom <= window.innerHeight;
            this.isDownloadAppBannerScrolledIntoView = topShown && bottomShown;
            if (this.isDownloadAppBannerScrolledIntoView) {
                this.gaService.gaEventFun({
                    action: 'download_app_banner_view',
                    label: this.router.url,
                });
            }
        }
    }
}
